'use client';

import { parseUtmParams, convertUtmParamsForWebhooks } from '@web-store-platforms/utils';
import { UTM_PARAMS } from '@/lib/consts/utms';
import { API_ROUTES } from '@/lib/consts/api';
import { httpClient } from '@/lib/http-client';
import { webStorageUtil } from '@/lib/storage/webStorageUtil';
import { ESessionStorageKeys } from '@/lib/storage/enums';
import { getStoreDomain } from '@/lib/utils/domain-client';

export { convertUtmParamsForWebhooks };

export const getUtmParams = (): Record<string, string> => {
    if (typeof window === 'undefined') {
        return {};
    }

    const utmData = parseUtmParams(window.location.search);

    if (Object.keys(utmData).length > 0) {
        webStorageUtil.set(ESessionStorageKeys.UTM_PARAMS, utmData);
        return utmData;
    }

    const storedUtmParams = webStorageUtil.get(ESessionStorageKeys.UTM_PARAMS);
    if (storedUtmParams) return storedUtmParams;

    return {};
};

export const getUtmHeaders = (): Record<string, string> => {
    const utmParams = getUtmParams();
    const headers: Record<string, string> = {};

    UTM_PARAMS.forEach((key) => {
        const value = utmParams[key];
        if (value) {
            headers[`x-ac-${key}`] = value;
        }
    });

    return headers;
};

export const saveUtms = async (accessToken: string): Promise<void> => {
    const utmParams = getUtmParams();
    if (Object.keys(utmParams).length === 0) return;

    const domain = getStoreDomain();
    if (!domain) return;

    await httpClient.post(API_ROUTES.UTMS(domain), { accessToken, ...convertUtmParamsForWebhooks(utmParams) });
};

export const getUtms = async (accessToken: string): Promise<Record<string, string>> => {
    const domain = getStoreDomain();
    if (!domain) return {};

    const response = await httpClient.get<Record<string, string>>(`${API_ROUTES.UTMS(domain)}?accessToken=${accessToken}`);
    return response.data ?? {};
};
